import { doCheckOffers } from "../../../../../logics/src/utils/checkOffers";
import { getOfferMessages } from "../../../../../logics/src/utils/helpers";
import { PAYMENT_MODES } from "constants/paymentModes";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { getStringFromId } from "helpers/vernacular";
import { SIMPL_FLOW } from "layouts/Payment/common/dependencies/constants";
import { getPlatform } from "../../../../../helpers/index";
import { getSimplRelinkStatus } from "../../../../../store/payment/services";
import { BUTTON_TYPE } from "constants/index";
import { IOfferMessage, ISavedsnplConfig, OfferDataInterface } from "../@types/savedMethods";
import { PaymentOfferRule } from "logics/src/utils/@types";
import { formatNumber } from "helpers/utils/numberFormatter";

/**
 * If simplDto is not present in paymentInfo then return empty object
 */
export const savedSimpl = ({
    paymentContext,
    applicationData,
    orderAmount: grandTotal,
    doPayment,
    toggleOfferBottomSheet,
    strikedPaymentText,
    theme,
}:any)=>{
    const platform = getPlatform();
    const { deviceType } = applicationData;
    const {paymentInfo, offersData: cartRules, setLoading,simplEligibleInfo,setIsRelinkBottomSheetVisible,isRelinkBottomSheetVisible,setSimplEligibleInfo} = paymentContext;
    const { simplDTO, lastPaymentInfo } = paymentInfo;
    const cartInfo = paymentContext?.cartInfo;
    const initialOrderAmount = cartInfo?.grandTotal;
    /**
     * if simplEligibleInfo is empty or simplDTO is null then we are not showing smipl   
     */
    if(!simplEligibleInfo?.statusCode || Object.keys(simplDTO || {}).length === 0){
      return {} as ISavedsnplConfig;
    }

    let phoneNumber = simplDTO?.phone || lastPaymentInfo?.paymentInfo;
    let simplOfferText = "";

    const offerKeys = (simplDTO?.offerKeys || lastPaymentInfo?.offerKeys) || [];
    let offerMessages: IOfferMessage[] = [];
    let revisedBtnText = strikedPaymentText;
    let offerData = {} as OfferDataInterface;
    let offers: any[] = [];
    let simplOffersData = {} as OfferDataInterface;
    let simplOfferMessages: {
      text?: string;
      success: boolean;
      endIcon: string;
    }[] = [];

    if (offerKeys?.length) {
      offerKeys.forEach((offerKey: string) => {
        let offer = cartRules.paymentRules.filter(
          (rule: PaymentOfferRule) => rule.ruleKey === offerKey
        );
        offers.push(offer);
        offers = offers.flat();
      });
      if (offers?.length > 1) {
        offers = offers.sort(
          (a: PaymentOfferRule, b: PaymentOfferRule) => b?.priority - a?.priority
        );
      }

      if (offers?.length) {
        const keys = offers.map(offer => offer?.ruleKey);
        offerData = doCheckOffers(false, PAYMENT_MODES.SIMPL, cartRules, paymentInfo, keys);
        if (offerData?.hasOffers && offerData?.finalOrderAmount) {
          offerMessages = getOfferMessages(offerData, theme, () =>
            toggleOfferBottomSheet(offerData)
          );

          revisedBtnText = getStringFromId(
            VERNACULAR_STRING_IDS.DYNAMIC_PAY_WITH_STRIKED_AMOUNT,
            `Pay ₹${formatNumber(offerData?.finalOrderAmount)} &nbsp; <del> ₹${formatNumber(grandTotal)}</del>`,
            {
              oldAmount: grandTotal,
              newAmount: offerData?.finalOrderAmount || "",
            }
          );
        }
      }
    }

    let offerDetailConfig = {};
    simplOfferMessages = offerMessages;
    simplOffersData = offerData;

    const simplFinalOrderAmount = offerData?.finalOrderAmount || 0;
  
    let isSimplLoading  = false;
    let isSimplEligible = false;
    let simplMessage = "";
    let simplFlow = "";
    let simplRedirectionUrl = "";

    let payNowText = getStringFromId(
      VERNACULAR_STRING_IDS.DYNAMIC_PAY,
      `Pay ₹${formatNumber(grandTotal)}`,
      { count: grandTotal }
    );
  
    let simplRevisedPayNowText = getStringFromId(
      VERNACULAR_STRING_IDS.DYNAMIC_PAY_WITH_STRIKED_AMOUNT,
      `Pay &nbsp; <del> ₹${formatNumber(initialOrderAmount)}</del> &nbsp; ₹${formatNumber(simplFinalOrderAmount)}`,
      { oldAmount: initialOrderAmount, newAmount: simplFinalOrderAmount || "" }
    );
  
    let linkAndPay = getStringFromId(
      VERNACULAR_STRING_IDS.DYNAMIC_LINK_AND_PAY,
      `Link & Pay ₹${formatNumber(grandTotal)}`,
      { count: grandTotal }
    );
  
    let simplLinkAndPayRevisedText = getStringFromId(
      VERNACULAR_STRING_IDS.DYNAMIC_LINK_AND_PAY_WITH_STRIKED_AMOUNT,
      `Link & Pay &nbsp; <del> ₹${formatNumber(initialOrderAmount)}</del> &nbsp; ₹${formatNumber(simplFinalOrderAmount)}`,
      { oldAmount: initialOrderAmount, newAmount: simplFinalOrderAmount || "" }
    );
  
    let relinkAndPay = getStringFromId(
      VERNACULAR_STRING_IDS.DYNAMIC_RELINK_AND_PAY,
      `Relink & Pay ₹${formatNumber(grandTotal)}`,
      { count: grandTotal }
    );
  
    let simplRelinkAndPayRevisedText = getStringFromId(
      VERNACULAR_STRING_IDS.DYNAMIC_RELINK_AND_PAY_WITH_STRIKED_AMOUNT,
      `Relink & Pay &nbsp; <del> ₹${formatNumber(initialOrderAmount)}</del> &nbsp; ₹${formatNumber(simplFinalOrderAmount)}`,
      { oldAmount: initialOrderAmount, newAmount: simplFinalOrderAmount || "" }
    );
  
    let simplButtonText = payNowText;
    let simplRevisedButtonText = simplRevisedPayNowText;
    

    if(simplEligibleInfo?.success && simplEligibleInfo?.data){
    const message = simplEligibleInfo?.data?.message;
    const statusCode = simplEligibleInfo?.data?.statusCode;
    const url = simplEligibleInfo?.data.redirectionUrl || '';
    simplMessage = message;
    simplFlow = statusCode;

      switch (statusCode) {
        case SIMPL_FLOW.ELIGIBLE:
          isSimplEligible = true;
          break;
        case SIMPL_FLOW.LINK_AND_PAY:
          isSimplEligible = true;
          simplRedirectionUrl = url;
          break;
        case SIMPL_FLOW.RELINK_AND_PAY:
          isSimplEligible = true;
          break;
        default:
          isSimplEligible = false;
          break;
      }

    }else{
      const statusCode = simplEligibleInfo?.statusCode;
      const message = simplEligibleInfo?.message;
      isSimplEligible = false;
      simplFlow = statusCode;
      simplMessage = message;      
    }


  
    const checkIsSimplRelinked = () => {
      const params = {
        amount: simplFinalOrderAmount || grandTotal,
        phone: phoneNumber,
        deviceType,
      };
      getSimplRelinkStatus(params)
        .then(
          (response: {
            success: boolean;
            message: string;
            statusCode: string;
            data: {
              redirectionUrl: string;
              message: string;
              statusCode: string;
              reLinkingRequired: boolean;
            };
          }) => {
            if (response?.success && response?.data) {
              const message = response?.data?.message;
              const statusCode = response?.data?.statusCode;
              const url = response?.data?.redirectionUrl;
              simplMessage = message;
              simplFlow = statusCode;
              simplRedirectionUrl = url;
              if (statusCode == SIMPL_FLOW.LINK_AND_PAY) {
                doPayment(PAYMENT_MODES.SIMPL,{
                  phone: phoneNumber,
                  simplFlow: statusCode,
                  simplRedirectionUrl: url,
                  simplFinalOrderAmount,
                  grandTotal,
                  mode: PAYMENT_MODES.SIMPL,
                  offerData: simplOffersData,
                  isSaved:true
                });
              }
            } else {
              setSimplEligibleInfo(response);
            }
            setIsRelinkBottomSheetVisible(false);
            isSimplLoading = false;
          }
        )
        .catch(() => {
          setIsRelinkBottomSheetVisible(false);
          isSimplLoading = false;
        });
    };
  
    const onRelinkAndPayBottomSheetSuccess = () => {
      checkIsSimplRelinked();
    };
  
    const onRelinkAndPayBottomSheetDismiss = () => {
      setIsRelinkBottomSheetVisible(false);
    };

        
    switch (simplFlow) {
      case SIMPL_FLOW.LINK_AND_PAY:
        simplButtonText = linkAndPay;
        if (simplOffersData?.hasOffers) {
          simplRevisedButtonText = getStringFromId(
            VERNACULAR_STRING_IDS.DYNAMIC_LINK_AND_PAY_WITH_STRIKED_AMOUNT,
            `Link & Pay &nbsp; ₹${formatNumber(simplOffersData?.finalOrderAmount)} &nbsp; <del>₹${formatNumber(initialOrderAmount)}</del>`,
            {
              oldAmount: initialOrderAmount,
              newAmount: simplOffersData?.finalOrderAmount || "",
            }
          );
        } else if (simplFinalOrderAmount) {
          simplRevisedButtonText = simplLinkAndPayRevisedText;
        } else {
          simplRevisedButtonText = "";
        }
        break;
      case SIMPL_FLOW.RELINK_AND_PAY:
        simplButtonText = relinkAndPay;
        if (simplOffersData?.hasOffers) {
          simplRevisedButtonText = getStringFromId(
            VERNACULAR_STRING_IDS.DYNAMIC_LINK_AND_PAY_WITH_STRIKED_AMOUNT,
            `Relink & Pay &nbsp; ₹${formatNumber(simplOffersData?.finalOrderAmount)} &nbsp; <del>₹${formatNumber(initialOrderAmount)}</del>`,
            {
              oldAmount: initialOrderAmount,
              newAmount: simplOffersData?.finalOrderAmount || "",
            }
          );
        } else if (simplFinalOrderAmount) {
          simplRevisedButtonText = simplRelinkAndPayRevisedText;
        } else {
          simplRevisedButtonText = "";
        }
        break;
      default:
        simplButtonText = payNowText;
        if (simplOffersData?.hasOffers) {
          simplRevisedButtonText = getStringFromId(
            VERNACULAR_STRING_IDS.DYNAMIC_LINK_AND_PAY_WITH_STRIKED_AMOUNT,
            `Pay &nbsp; ₹${formatNumber(simplOffersData?.finalOrderAmount)} &nbsp; <del>₹${formatNumber(initialOrderAmount)}</del>`,
            {
              oldAmount: initialOrderAmount,
              newAmount: simplOffersData?.finalOrderAmount || "",
            }
          );
        } else if (simplFinalOrderAmount) {
          simplRevisedButtonText = simplRelinkAndPayRevisedText;
        } else {
          simplRevisedButtonText = "";
        }
    }
  
    const simplTitle = getStringFromId(
      VERNACULAR_STRING_IDS.SIMPL_TITLE,
      VERNACULAR_DEFAULT_MESSAGES.SIMPL_TITLE
    );
    const relinkAndPayBottomSheetTitle = getStringFromId(
      VERNACULAR_STRING_IDS.RELINK_BOTTOM_SHEET_TITLE,
      VERNACULAR_DEFAULT_MESSAGES.RELINK_BOTTOM_SHEET_TITLE
    );
    const relinkAndPayBottomSheetSubTitle = getStringFromId(
      VERNACULAR_STRING_IDS.RELINK_BOTTOM_SHEET_SUBTITLE,
      VERNACULAR_DEFAULT_MESSAGES.RELINK_BOTTOM_SHEET_SUBTITLE
    );
    const relinkSuccessButtonText = getStringFromId(
      VERNACULAR_STRING_IDS.RELINK_BOTTOM_SHEET_SUCCESS_BUTTON_TEXT,
      VERNACULAR_DEFAULT_MESSAGES.RELINK_BOTTOM_SHEET_SUCCESS_BUTTON_TEXT
    );
    const relinkDismissButtonText = getStringFromId(
      VERNACULAR_STRING_IDS.RELINK_BOTTOM_SHEET_DISMISS_BUTTON_TEXT,
      VERNACULAR_DEFAULT_MESSAGES.RELINK_BOTTOM_SHEET_DISMISS_BUTTON_TEXT
    );
  
    let simplSubTitleColor = "";
    if (simplButtonText === relinkAndPay) {
      simplSubTitleColor = theme.colors.notificationWarningFill;
    } else if (!isSimplEligible) {
      simplSubTitleColor = theme.colors.negative;
    } else if (isSimplEligible) {
      simplSubTitleColor = theme.colors.notificationPositiveText;
    }
    const simplLoadingText = getStringFromId(
      VERNACULAR_STRING_IDS.PLEASE_WAIT_WHILE,
      VERNACULAR_DEFAULT_MESSAGES.PLEASE_WAIT_WHILE
    );
  
    let text;
    if (isSimplLoading) {
      text = {
        text: simplLoadingText,
        info: true,
        leadingIcon: "",
        success: "",
      };
    } else if (isSimplEligible) {
      text = {
        text: simplMessage,
        info: true,
        leadingIcon: getIcons(platform, ICONS_NAMES.SUCCESS_ICON),
        success: true,
      };
    } else if (!isSimplLoading && !isSimplEligible) {
      text = {
        text: simplMessage,
        info: true,
        leadingIcon: getIcons(platform, ICONS_NAMES.WARN_ICON),
        warn: true,
      };
    } else {
      text = {
        text: "",
        info: true,
        leadingIcon: "",
        success: "",
      };
    }
    
    const doSavedPaymentSimpl = () => {
      setLoading(true);
      if (simplFlow === SIMPL_FLOW.ELIGIBLE) {
        doPayment(PAYMENT_MODES.SIMPL,{
          phone: phoneNumber,
          simplFlow,
          mode: PAYMENT_MODES.SIMPL,
          offerData: simplOffersData,
          isSaved:true
        });
      } else if (simplFlow === SIMPL_FLOW.LINK_AND_PAY) {
        doPayment(PAYMENT_MODES.SIMPL,{
          phone: phoneNumber,
          simplFlow,
          simplRedirectionUrl,
          simplFinalOrderAmount,
          grandTotal,
          mode: PAYMENT_MODES.SIMPL,
          offerData: simplOffersData,
          isSaved:true
        });
      } else if (simplFlow === SIMPL_FLOW.RELINK_AND_PAY) {
        setIsRelinkBottomSheetVisible(true);
        setLoading(false);
      }
    };
    
    simplRevisedButtonText = !simplRevisedButtonText ? strikedPaymentText : simplRevisedButtonText;
    
    /**
     * savedSimpl config is for showing simpl payment method on saved payment screen
     */
    const config = {
      title: simplTitle,
      subTitle: phoneNumber,
      leadingIcon: getIcons(platform, ICONS_NAMES.SIMPL),
      isPaymentEnabled: true,
      payNowText: simplButtonText,
      revisedPayNowText: simplRevisedButtonText,
      doPayment: doSavedPaymentSimpl,
      isSubmitButtonDisabled: !isSimplEligible,
      alert: text,
      offerText: simplOfferText,
      isEligible: isSimplEligible,
      offerMessages: simplOfferMessages,
      offerDetailConfig,
      relinkBottomSheetConfig: {
        icon: getIcons(platform, ICONS_NAMES.CLEAR),
        maxHeight: 85,
        theme: theme,
        title: relinkAndPayBottomSheetTitle,
        subTitle: relinkAndPayBottomSheetSubTitle,
        successButtonText: relinkSuccessButtonText,
        dismissButtontext: relinkDismissButtonText,
        isVisible: isRelinkBottomSheetVisible,
        onSuccess: onRelinkAndPayBottomSheetSuccess,
        onDismiss: onRelinkAndPayBottomSheetDismiss,
      },
      pymentMethod: PAYMENT_MODES.SIMPL,
      priority: 0,
      theme,
      buttonType: BUTTON_TYPE.MEDIUM
    };
    return config as ISavedsnplConfig;
}